module.exports = __webpack_public_path__ + "img/powered-by-av.e96d40e4.svg";